// third-party
import { FormattedMessage } from 'react-intl';

// assets
import ContentPasteOutlinedIcon from '@mui/icons-material/ContentPasteOutlined';
import LocalPharmacyOutlinedIcon from '@mui/icons-material/LocalPharmacyOutlined';
import PointOfSaleOutlinedIcon from '@mui/icons-material/PointOfSaleOutlined';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';

// type

// icons
const icons = { ContentPasteOutlinedIcon, LocalPharmacyOutlinedIcon, PointOfSaleOutlinedIcon, ReceiptLongOutlinedIcon };

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const invoice = {
  id: 'invoice',
  title: <FormattedMessage id="Sale Invoicing" />,
  icon: icons.ContentPasteOutlinedIcon,
  type: 'group',
  children: [
    {
      id: 'invoice/list',
      title: <FormattedMessage id="Past Invoices" />,
      type: 'item',
      url: '/invoice/list',
      icon: icons.ContentPasteOutlinedIcon
    },
    {
      id: 'patient-list',
      title: <FormattedMessage id="OPD Billing" />,
      type: 'item',
      url: '/reception/patient-list',
      icon: icons.PointOfSaleOutlinedIcon
    },
    {
      id: 'invoice/lab-invoice',
      title: <FormattedMessage id="Procedure Invoice" />,
      type: 'item',
      url: '/invoice/lab-invoice',
      icon: icons.ReceiptLongOutlinedIcon,
      breadcrumbs: false,
      visible: (roles, isAdmin) => roles.includes('lab_billing') || isAdmin
    },
    {
      id: 'invoice/pharmacy-invoice',
      title: <FormattedMessage id="Pharmacy Invoice" />,
      type: 'item',
      url: '/invoice/pharmacy-invoice',
      icon: icons.LocalPharmacyOutlinedIcon,
      breadcrumbs: false,
      visible: (roles, isAdmin) => roles.includes('pharmacy_biller') || isAdmin
    },
  ]
};

export default invoice;
